import React, { useEffect } from 'react';
import { useTenant } from '@libs/contexts/TenantContext';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const TenantSelector = () => {
  const {
    selectedTenant,
    setSelectedTenant,
    availableTenants,
    loading,
    error,
    membershipsByTenantId,
  } = useTenant();

  if (loading) {
    return (
      <div className="flex items-center space-x-2 text-sm text-gray-500">
        <LoadingSpinner size={16} />
        <span>Loading tenants...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-sm text-red-500">
        {error}
      </div>
    );
  }

  if (availableTenants.length === 0) {
    return (
      <div className="text-sm text-yellow-600">
        No tenants available. Contact your administrator.
      </div>
    );
  }

  const handleTenantChange = (e) => {
    const tenantId = e.target.value;
    const tenant = availableTenants.find(t => t.id === tenantId);
    setSelectedTenant(tenant);
  };

  const getTenantLabel = (tenant) => {
    const membership = membershipsByTenantId?.[tenant.id];
    const baseName = tenant.name || tenant.id;
    if (membership && membership.role) {
      return `${baseName} (${membership.role})`;
    }
    return baseName;
  };

  // Tenant selector hidden - single tenant mode
  // Auto-select first tenant if not selected
  useEffect(() => {
    if (loading) return;
    if (selectedTenant) return;
    if (!Array.isArray(availableTenants) || availableTenants.length === 0) return;
    setSelectedTenant(availableTenants[0]);
  }, [availableTenants, loading, selectedTenant, setSelectedTenant]);
  
  return null;
};

export default TenantSelector;
